var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dynamic-banner",style:({'background-image': ("url('" + (_vm.getBgImage()) + "')")}),attrs:{"id":"banner"}},[_c('div',{staticClass:"dynamic-banner__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }